export const Scope = function () {
	const watchers = [];
	const self = this;

	function init_val () {}

	this.watch = function (watch_fn, listener_fn) {
		const watcher =
		{
			watch_fn: watch_fn,
			listener_fn: listener_fn || function () {},
			last: init_val
		};

		watchers.push(watcher);
	};

	this.reset = function () {
		watchers.length = 0
	};

	this.digest = function (ignore_initial) {

		console.log("digest")

		let new_val, old_val, dirty;
		let ttl = 10;
		do
		{

			if (dirty && !(ttl--)) throw "10 digest iterations reached";

			for (const i in watchers)
			{
				old_val = watchers[i].last;
				new_val = watchers[i].watch_fn(old_val, self)
				const eq = (new_val === old_val)

				if (eq) dirty = false;

				if (!eq)
				{
					console.log("change detect")

					const is_initial = old_val == init_val;

					old_val = is_initial ? new_val : old_val;
					watchers[i].last = new_val;
					if (!is_initial || ignore_initial)
					{
						console.log("new value")
						watchers[i].listener_fn(new_val, old_val, self);
					}

					dirty = true;
				}
			}
		} while (dirty);
	};

	return this;
};
